import {css} from 'styled-components';

/**
 * This is simply a connection between the base styles and the component that utilizes them.
 * Without it, we might overlook removing this code when we refactor or even eliminate the animations.
 * The animation keyframes are added globally, the animations will collide if we add the same name
 * for different animations, this enum make sure we use a unique name for each new custom animation
 */
export enum GLOBAL_KEYFRAMES {
  fadeEnter = 'fadeEnter',
  fadeExit = 'fadeExit',
  cardsSliderAmbientFadeEnter = 'cardsSliderAmbientFadeEnter',
}

export const keyFrames = css`
  @keyframes fadeEnter {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeExit {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
`;
